import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCol,
  CRow,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CModalHeader,
  CModalBody,
  CModal,
  CModalTitle,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilPeople, cilPlus } from "@coreui/icons";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import toast from "react-hot-toast";
import {
  getRouteList,
  getSearchAbleRoutes,
  getSingleRoute,
} from "../../services/route.services";
import { getSearchedBookingOrderList } from "../../services/booking.services";
import {
  useParams,
  useNavigate,
  Navigate,
  useSearchParams,
} from "react-router-dom";
import {
  getBulkTripInfo,
  createTrip,
  getTripList,
  assignOrdersToTrip,
} from "src/services/trip.services";
import { getSearchedUser } from "src/services/user.services";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import {
  getActiveCountryList,
  getSingleCountry,
} from "src/services/country.services";
import ReactSelect from "react-select";
import { useMutation, useQuery } from "@tanstack/react-query";
import TripTableData from "./TripTableData";
import useTableSort from "src/__custom_hook/useTableSort";

const schema = z.object({
  tripName: z.string().optional(),
  tripId: z.string().min(1, "Required"),
  orderIds: z.array(z.string()).refine((data) => data.length > 0, {
    message: "OrderIds must be a non-empty array of strings",
  }),
  tripRoute: z.string().min(1, "Required"),
  tripStartTime: z.string().min(1, "Required"),
  tripAssignedBy: z.string().optional(),
  //tripTagId: z.string().min(1, "Required"),
  // tripVehicleId: z.string().min(1, "Required"),
  tripAssignedTo: z.string().min(1, "Required"),
  tripRemarks: z.string().optional(),
  country: z.string(),
  priority: z.string(),
});

const CreateBulkTrip = ({
  id: propId,
  priority: propPriority,
  country: propCountry,
  handleCloseModal,
}) => {
  const { sortConfig, handleClickColumnSort } = useTableSort();
  const [isLoading, setIsLoading] = useState(false);
  const [bookingOrderData, setBookingOrderData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const [routeOptions, setRouteOptions] = useState([]);
  const [selectedRouteId, setSelectedRouteId] = useState(null);

  const [driverOptions, setDriverOptions] = useState([]);
  const [selectedDriverId, setSelectedDriverId] = useState(null);
  const [driverIdArray, setDriverIdArray] = useState([]);
  const [allDriverData, setAllDriverData] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [countrySelectOptions, setCountrySelectOptions] = useState([]);
  const [tripList, setTripList] = useState([]);

  const [showTripListModal, setShowTripListModal] = useState(false);
  const [user, setUser] = useState(
    localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : null
  );
  const { id: paramsId } = useParams();
  const id = propId || paramsId;

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [defaultErrorMessage, setDefaultErrorMessage] = useState(
    '"Something went wrong. Please try again"'
  );
  const [isSubmitted, setIsSubmitted] = useState(false);
  const {
    register,
    setValue,
    handleSubmit,
    reset,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      tripName: "",
      tripId: "TRI" + new Date().getTime(),
      orderIds: [],
      tripRoute: "",
      tripStartTime: `${new Date().getHours()}:${new Date().getMinutes()}`,
      tripAssignedBy: "",
      // tripVehicleId: "",
      tripTagId: "",
      tripAssignedTo: "",
      tripRemarks: "",
      country: "",
      priority: "",
    },
    resolver: zodResolver(schema),
  });

  // Get selected booking orders information fo thi strip

  const getActiveCountries = () => {
    getActiveCountryList({ limit: 100, page: 1 })
      .then((response) => {
        if (response.success && response.data) {
          let options = response.data.map((element) => ({
            value: `${element._id}`,
            label: `${element.name}`,
          }));
          setCountrySelectOptions(options);
        }
      })
      .catch((error) => console.log(error));
  };

  const openTripQuery = useQuery(
    {
      queryKey: ["open-trip"],
      queryFn: () =>
        getTripList({ limit: 100, page: 1, tripStatus: "assigned,inProgress" }),
      enabled: showTripListModal, // Refactored line
    },
    {
      refetchOnWindowFocus: false, // Added option to prevent unnecessary refetching
    }
  );

  const onSubmit = (data) => {
    if (!selectedId) {
      return false;
    }
    setIsSubmitted(true);
    toast
      .promise(
        createTrip(data),
        {
          loading: "Loading",
          success: "Bulk Trip assigned Succesfully",
          error: (err) => {
            return err.response &&
              err.response.data &&
              err.response.data.message
              ? err.response.data.message
              : defaultErrorMessage;
          },
        },
        {
          id: "assign-trip",
        }
      )
      .then(async (response) => {
        reset();
        customFormReset();
        if (propId && handleCloseModal) {
          console.log("i am here");
          setBookingOrderData([]);
          setSelectedId(null);
          setShowTripListModal(false);
          handleCloseModal();
        } else {
          navigate("/manage-trip", {
            replace: true,
          });
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  const customFormReset = () => {
    setValue("orderIds", []);
    setValue("tripId", "TRI" + new Date().getTime());
    setValue("bookingOrderId", "");

    setSelectedRouteId("");
    setValue("tripRoute", "");

    setSelectedDriverId("");
    setValue("tripAssignedTo", "");
    setSelectedId(null);
  };

  const onError = (err) => {
    console.error(err);
    setIsSubmitted(false);
  };

  const getSelectedBookingOrderInfo = (id) => {
    toast.dismiss();

    getBulkTripInfo(id)
      .then(async (response) => {
        toast.dismiss();
        const fetchedBookingOrderData = response.data;

        if (fetchedBookingOrderData) {
          const orderIdArray = fetchedBookingOrderData.map(
            (order) => order._id
          );
          setValue("orderIds", orderIdArray);
          setBookingOrderData(fetchedBookingOrderData);
          prepareRouteData(fetchedBookingOrderData);
        }
      })
      .catch((error) => {
        toast.dismiss();
        console.error(error);
      });
  };

  const prepareRouteData = (bookingOrders) => {
    if (bookingOrders?.length > 0) {
      const refrenceRouteId = bookingOrders[0].tripRoute;
      if (refrenceRouteId) {
        if (
          bookingOrders.every((order) => order.tripRoute === refrenceRouteId)
        ) {
          getSingleRouteDetails(refrenceRouteId);
        } else {
          getCountryMultipleTypeRoute("multiple", bookingOrders[0].country);
        }
      } else {
        getCountryMultipleTypeRoute("multiple", bookingOrders[0].country);
      }
    }
  };

  const handleChangeRoute = (selectedOption) => {
    if (selectedOption) {
      setSelectedRouteId(selectedOption);
      setValue("tripRoute", selectedOption.value);
    } else {
      setSelectedRouteId("");
      setValue("tripRoute", "");
    }
  };

  const getSingleRouteDetails = (id) => {
    getSingleRoute(id)
      .then(async (response) => {
        const fetchedRouteData = response.data;
        // if (fetchedRouteData?.country?._id) {
        //   console.log(fetchedRouteData);
        //   console.log("herer");
        //   setValue("country", fetchedRouteData.country._id);
        // }
        if (fetchedRouteData) {
          let option = {
            label: fetchedRouteData.name,
            value: fetchedRouteData._id,
          };
          setSelectedRouteId(option);
          setRouteOptions([option]);
          setValue("tripRoute", fetchedRouteData._id);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getCountryEmergencyRoute = async (tripUrgency, country) => {
    try {
      const response = await getRouteList({ tripUrgency, country });
      if (response?.success && response?.data.length > 0) {
        const routeInfo = response.data[0];
        setSelectedRouteId({
          label: routeInfo.name,
          value: routeInfo._id,
        });
        setValue("tripRoute", routeInfo._id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCountryMultipleTypeRoute = async (routeType, country) => {
    try {
      const response = await getRouteList({ routeType, country });
      if (response?.success && response?.data.length > 0) {
        const routeInfo = response.data[0];
        setSelectedRouteId({
          label: routeInfo.name,
          value: routeInfo._id,
        });
        setValue("tripRoute", routeInfo._id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getRouteNameList = (searchString) => {
    getSearchAbleRoutes({ searchString })
      .then(async (response) => {
        const fetchedRouteData = response.data;
        let options = [];
        let routeIdArray = [];

        fetchedRouteData.forEach((element) => {
          // if(element._id === reservedRuteId)
          const option = { value: `${element._id}`, label: `${element.name}` };
          options.push(option);
          routeIdArray.push(element._id);
        });
        setRouteOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleOnInputChangeRoute = (searchValue) => {
    const matchingRoutes = routeOptions.filter((route) =>
      route.label.toLowerCase().includes(searchValue.toLowerCase())
    );
    if (matchingRoutes.length <= 0) {
      getRouteNameList(searchValue);
    }
  };

  const handleChangeDriver = (selectedOption) => {
    if (selectedOption) {
      setSelectedDriverId(selectedOption);
      setValue("tripAssignedTo", selectedOption.value);
      const driver = allDriverData.find((x) => x._id === selectedOption.value);
      // if (driver && driver.vehicleId) {
      if (driver && driver?.tagId) {
        setValue("tripTagId", driver.tagId);
      }
    } else {
      setSelectedDriverId("");
      setValue("tripRtripAssignedTooute", "");
    }
  };

  const handleOnInputChangeDriver = (selectedOption) => {
    const expectedData = driverIdArray.find((a) => a.includes(selectedOption));
    if (!expectedData) {
      getSearchedUserList(selectedOption);
    }
  };

  const getSearchedUserList = (value) => {
    const params = {
      limit: 10,
      page: 1,
      type: "driver",
      name: value,
      availibility: true,
    };

    getSearchedUser(params)
      .then(async (response) => {
        const fetchedDriverData = response.data;
        setAllDriverData(fetchedDriverData);
        let options = [];
        let driverIdArray = [];

        fetchedDriverData.forEach((element) => {
          const option = {
            value: `${element._id}`,
            label: `${
              element.firstName +
              " " +
              element.lastName +
              "-" +
              element.employeeCode
            }`,
          };
          options.push(option);
          driverIdArray.push(element._id);
        });
        setDriverIdArray(driverIdArray);
        setDriverOptions(options);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getCountryDetails = async (id) => {
    try {
      const response = await getSingleCountry(id);
      if (response.success) {
        setSelectedCountry({
          value: response.data._id,
          label: response.data.name,
        });
        setValue("country", response.data._id);
      }
      return response;
    } catch (error) {
      console.log(error);
    }
  };

  const handleCountryChange = (selectedOption) => {
    console.log("country handle change");
    if (selectedOption) {
      setSelectedCountry(selectedOption);
      setValue("country", selectedOption.value);
    } else {
      setSelectedCountry(null);
      setValue("country", "");
    }
  };

  const assignToTripMutation = useMutation({
    mutationKey: ["assignToTrip"],
    mutationFn: (data) => assignOrdersToTrip(data),
    onMutate: () => {
      toast.loading("Assigning Orders...", { id: "assign-trip" });
    },
    onSuccess: (res) => {
      toast.dismiss("assign-trip");
      const data = res.data;
      if (data.success) {
        toast.success(data.message);
        setShowTripListModal(false);
        // navigate("/manage-trip");
        // for new-tab navigation
        window.open('/manage-trip', '_blank');
        if (handleCloseModal) {
          setBookingOrderData([]);
          handleCloseModal();
        } else {
          navigate("/manage-trip", { replace: true });
        }
      }
    },
    onSettled: () => {
      toast.dismiss("assign-trip");
    },
  });

  const onRowClick = (tripId) => {
    const payload = {
      tripId,
      orderIds: bookingOrderData.map((order) => order._id),
    };

    assignToTripMutation.mutate(payload);
  };

  useEffect(() => {
    if (id) {
      setBookingOrderData([]);
      getSelectedBookingOrderInfo(id);
      setSelectedId(id);
    }
  }, [id]);

  useEffect(() => {
    if (user) {
      setValue("tripAssignedBy", user.id);
      if (user?.country) {
        setValue("country", user.country._id);
        setSelectedCountry({
          value: user?.country?._id,
          label: user?.country?.name,
        });
      }

      if (user?.userType === "superAdmin") {
        getActiveCountries();
      }
    }
  }, [user]);

  useEffect(() => {
    if (
      (searchParams.get("priority") &&
        searchParams.get("priority") !== "null" &&
        searchParams.get("priority") !== "undefined") ||
      propPriority
    ) {
      const priority = searchParams.get("priority") || propPriority;
      if (priority !== "" && priority === "emergency") {
        setValue("priority", priority);
      }
    } else {
      setValue("priority", "normal");
    }

    if (
      (searchParams.get("country") &&
        searchParams.get("country") !== "null" &&
        searchParams.get("country") !== "undefined") ||
      propCountry
    ) {
      getCountryDetails(searchParams.get("country") || propCountry);
    }

    if (
      ((searchParams.get("priority") &&
        searchParams.get("priority") !== "null" &&
        searchParams.get("priority") !== "undefined") ||
        propPriority) &&
      ((searchParams.get("country") &&
        searchParams.get("country") !== "null" &&
        searchParams.get("country") !== "undefined") ||
        propCountry)
    ) {
      const priority = searchParams.get("priority") || propPriority;
      const country = searchParams.get("country") || propCountry;
      getCountryEmergencyRoute(priority, country);
    }
  }, [searchParams, propPriority, propCountry]);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setUser(user);
    setValue("tripAssignedBy", user.id);
    getSearchedUserList("");
  }, []);

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          {!propId && (
            <>
              <CRow>
                <CCol sm={5}>
                  <h4 id="traffic" className="card-title mb-0">
                    Assign Bulk Trips
                  </h4>
                  {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
                </CCol>
              </CRow>
              <hr />
              <br />
            </>
          )}

          <CForm onSubmit={handleSubmit(onSubmit, onError)}>
            <CRow className="mb-3">
              {user?.userType === "superAdmin" && (
                <CCol md={6}>
                  <CRow>
                    <CFormLabel
                      htmlFor="name"
                      className="col-sm-3 col-form-label"
                    >
                      Country:
                    </CFormLabel>
                    <CCol md={8}>
                      <ReactSelect
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        options={countrySelectOptions}
                        isClearable={true}
                        placeholder="Select Country"
                        className="w-100"
                      />
                    </CCol>
                  </CRow>
                </CCol>
              )}

              {["superAdmin", "admin", "cvit"].includes(user?.userType) && (
                <CCol md={6}>
                  <CRow>
                    <CCol md={3}></CCol>
                    <CCol md={8}>
                      <CButton
                        color="btn-purple"
                        className="btn-purple w-100"
                        onClick={() => setShowTripListModal(true)}
                      >
                        View Open Trips
                      </CButton>
                    </CCol>
                  </CRow>
                </CCol>
              )}
            </CRow>
            <CRow>
              <CCol sm={6}>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="trip"
                    className="col-sm-3 col-form-label"
                  >
                    Trip Name:
                  </CFormLabel>

                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="tripName"
                      {...register("tripName")}
                    />
                    {errors.tripName?.message && (
                      <p className="error_text">{errors.tripName?.message}</p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="trip"
                    className="col-sm-3 col-form-label"
                  >
                    Trip ID:
                  </CFormLabel>

                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="tripId"
                      {...register("tripId")}
                      disabled={true}
                    />
                    {errors.tripId?.message && (
                      <p className="error_text">{errors.tripId?.message}</p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="trip"
                    className="col-sm-3 col-form-label"
                  >
                    Route Name:
                  </CFormLabel>
                  <CCol sm={8}>
                    <Select
                      value={selectedRouteId}
                      onChange={handleChangeRoute}
                      // onInputChange={handleOnInputChangeRoute}
                      options={routeOptions}
                      isClearable={false}
                      isDisabled={true}
                    />
                    {errors.tripRoute?.message && (
                      <p className="error_text">{errors.tripRoute?.message}</p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripStartTime"
                    className="col-sm-3 col-form-label"
                  >
                    Start Time:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      type="time"
                      id="tripStartTime"
                      {...register("tripStartTime")}
                    />
                    {errors.tripStartTime?.message && (
                      <p className="error_text">
                        {errors.tripStartTime?.message}
                      </p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripAssignedBy"
                    className="col-sm-3 col-form-label"
                  >
                    CVIT Officer:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormInput
                      disabled
                      type="text"
                      id="tripAssignedBy"
                      value={user.firstName + " " + user.lastName}
                    />
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm={6} className="d-none d-md-block">
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripAssignedTo"
                    className="col-sm-3 col-form-label"
                  >
                    Driver:
                  </CFormLabel>
                  <CCol sm={8}>
                    <Select
                      onInputChange={handleOnInputChangeDriver}
                      value={selectedDriverId}
                      onChange={handleChangeDriver}
                      options={driverOptions}
                      isClearable={true}
                    />
                    {errors.tripAssignedTo?.message && (
                      <p className="error_text">
                        {errors.tripAssignedTo?.message}
                      </p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripTagId"
                    className="col-sm-3 col-form-label"
                  >
                    Tag ID:
                  </CFormLabel>
                  {/* <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="tripVehicleId"
                      {...register("tripVehicleId")}
                    />
                    {errors.tripVehicleId?.message && (
                      <p className="error_text">
                        {errors.tripVehicleId?.message}
                      </p>
                    )}
                  </CCol> */}
                  <CCol sm={8}>
                    <CFormInput
                      type="text"
                      id="tripTagId"
                      {...register("tripTagId")}
                    />
                    {errors.tripTagId?.message && (
                      <p className="error_text">
                        {errors.tripTagId?.message}
                      </p>
                    )}
                  </CCol>
                </CRow>
                <CRow className="mb-3">
                  <CFormLabel
                    htmlFor="tripRemarks"
                    className="col-sm-3 col-form-label"
                  >
                    Remarks:
                  </CFormLabel>
                  <CCol sm={8}>
                    <CFormTextarea
                      id="tripRemarks"
                      rows={5}
                      {...register("tripRemarks")}
                    ></CFormTextarea>
                    {errors.tripRemarks?.message && (
                      <p className="error_text">
                        {errors.tripRemarks?.message}
                      </p>
                    )}
                  </CCol>
                </CRow>
              </CCol>

              <CRow className="mt-5">
                <div className="d-flex gap-3 justify-content-end">
                  <CButton
                    type="submit"
                    color="primary"
                    className="px-5 py-2 me-3"
                    disabled={isSubmitted}
                  >
                    Assign Trip
                  </CButton>
                </div>
              </CRow>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>

      <CCard className="mb-4">
        <CCardBody>
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Booking Order ID
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Transfer Order No.
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Seal/Bag No.
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  From Location
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  To Location
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">Loading...</CTableDataCell>
                </CTableRow>
              ) : bookingOrderData.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="9">No data available</CTableDataCell>
                </CTableRow>
              ) : (
                bookingOrderData.map((item, index) => (
                  <CTableRow
                    v-for="item in tableItems"
                    key={index}
                    data-id={item._id}
                    data-status={item.status}
                  >
                    <CTableDataCell className="text-center">
                      <CAvatar
                        size="md"
                        src={
                          item?.orderAcceptRejectBy?.avatar
                            ? item.orderAcceptRejectBy?.avatar
                            : demoAvatar
                        }
                        status="success"
                      />
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.bookingOrderId}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.transferOrderNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.sealBag?.serialNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <div>
                        {item.fromLocation
                          ? item.fromLocation.name
                          : item.toLocation.name}
                      </div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <div>{item.toLocation.name}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <CButton
                        color="primary"
                        className="text-capitalize"
                        style={{ color: "white" }}
                      >
                        {item.status === "cvit" ? "CDT" : item.status}
                      </CButton>
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
        </CCardBody>
      </CCard>

      <CModal
        scrollable
        backdrop="static"
        visible={showTripListModal}
        onClose={() => setShowTripListModal(false)}
        alignment="center"
        size="xl"
      >
        <CModalHeader onClose={() => setShowTripListModal(false)}>
          <CModalTitle id="StaticBackdropExampleLabel">Open Trips</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <TripTableData
            isLoading={openTripQuery?.isLoading}
            data={openTripQuery?.data?.data}
            onRowClick={onRowClick}
            {...{ sortConfig, handleClickColumnSort }}
          />
        </CModalBody>
      </CModal>
    </>
  );
};

export default CreateBulkTrip;
